//GLOBAL - components from npm
import React from "react";
import "./stackedBarChart.css";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

//ASSETS - icons, images...
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

// SERVICES

const initialData = [
  {
    name: "JAN",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "FEV",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "MAR",
    currentYearDetractor: 3,
    currentYearNeutral: 4,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "ABR",
    currentYearDetractor: 4,
    currentYearNeutral: 5,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "MAI",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "JUN",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "JUL",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "AGO",
    currentYearDetractor: 3,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "SET",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "OUT",
    currentYearDetractor: 2,
    currentYearNeutral: 3,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "NOV",
    currentYearDetractor: 1,
    currentYearNeutral: 2,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
  {
    name: "DEZ",
    currentYearDetractor: 0,
    currentYearNeutral: 1,
    currentYearPromoter: 10,
    lastYearDetractor: 0,
    lastYearNeutral: 1,
    lastYearPromoter: 10,
  },
];

function StackedBarChart({
  dataStart = initialData,
  currentYear = "2024",
  lastYear = "2023",
}) {
  //FUNCTIONS
  const CustomXAxisTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        dy={8}
        fill="rgba(0, 0, 0, 0.38)"
        textAnchor="middle"
        fontSize={12}
        fontFamily="Inter"
      >
        {payload.value}
      </text>
    );
  };

  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${18},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value.toFixed(2) + "%"}
        </text>
      </g>
    );
  };

  const CustomizedLabel = (props) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            gap: 16,
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 58,
            paddingTop: 6,
          }}
        >
          {props && props.payload
            ? props.payload.map((item, index) => {
                switch (item.value) {
                  case `Promotor - ${currentYear}`:
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 0,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#008908" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case `Promotor - ${lastYear}`:
                    return (
                      <div
                        key={`opt2${index}`}
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 1,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#42B649" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    );
                  case `Detrator - ${currentYear}`:
                    return (
                      <div
                        key={`opt3${index}`}
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 3,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#E10000" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          Detrator
                        </div>
                      </div>
                    );
                  case `Neutro - ${currentYear}`:
                    return (
                      <div
                        key={`opt4${index}`}
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          order: 2,
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <circle cx="6" cy="6" r="6" fill="#FFB300" />
                        </svg>
                        <div
                          style={{
                            fontSize: 12,
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "112.5%",
                            letterSpacing: 0.25,
                            color: "#757575",
                          }}
                        >
                          Neutro
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })
            : null}
        </div>
      </div>
    );
  };

  // USE EFFECTS
  /*
  useEffect(() => {
    getDataByHour(startDay, endDay, 54, 3002, 30, 30, true, null, null);
  }, []);
  */

  return (
    <div className="stackedBarChartComparisons">
      {dataStart && dataStart.length ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              // width={500}
              // height={300}
              data={dataStart}
              margin={{
                top: 20,
                right: 30,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid
                vertical={false}
                strokeDasharray="none"
                strokeWidth="1"
                stroke="rgba(0, 0, 0, 0.05)"
              />
              <XAxis dataKey="name" tick={<CustomXAxisTick />} />
              <YAxis
                domain={[0, 100]}
                axisLine={false}
                tick={<CustomYAxisTick />}
                tickFormatter={(value) => {
                  const isValidValue = value.toString().split(".").length <= 1;
                  if (isValidValue) {
                    return value.toFixed(2) + "%";
                  } else {
                    return "";
                  }
                }}
              />
              <Tooltip
                formatter={(value, name, props) => [
                  `${value.toFixed(2)}%`,
                  name,
                ]}
              />
              <Legend
                layout="horizontal"
                verticalAlign="bottom"
                align="center"
                fontSize={12}
                content={CustomizedLabel}
              />
              <Bar
                dataKey="currentYearDetractor"
                stackId="currentYear"
                name={`Detrator - ${currentYear}`}
                fill="#E10000"
                barSize={8}
              />
              <Bar
                dataKey="currentYearNeutral"
                stackId="currentYear"
                name={`Neutro - ${currentYear}`}
                fill="#FFB300"
                barSize={8}
              />
              <Bar
                dataKey="currentYearPromoter"
                stackId="currentYear"
                name={`Promotor - ${currentYear}`}
                fill="#008908"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
              <Bar
                dataKey="lastYearDetractor"
                stackId="lastYear"
                name={`Detrator - ${lastYear}`}
                fill="#E10000"
                barSize={8}
              />
              <Bar
                dataKey="lastYearNeutral"
                stackId="lastYear"
                name={`Neutro - ${lastYear}`}
                fill="#FED236"
                barSize={8}
              />
              <Bar
                dataKey="lastYearPromoter"
                stackId="lastYear"
                name={`Promotor - ${lastYear}`}
                fill="#42B649"
                barSize={8}
                radius={[4, 4, 0, 0]}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="card-table__area-empty">
          <EmptyState />
        </div>
      )}
    </div>
  );
}

export default StackedBarChart;
